import { Icons } from '@icons/icons';

import DynamicIconWrapper from '../DynamicIconWrapper';

import styles from './NotesTableCell.module.scss';

interface INotesTableCell {
	handleOpenNotes: (isEdit: boolean) => () => void;
	isNoteExist: boolean;
	isReadOnly?: boolean;
	viewText?: string;
	editText?: string;
	addText?: string;
}

const NotesTableCell = ({
	isNoteExist,
	isReadOnly = false,
	viewText = 'View note',
	editText = 'Edit note',
	addText = 'Add note',
	handleOpenNotes,
}: INotesTableCell) => {
	const editableNoteText = isNoteExist ? editText : addText;

	return (
		<div className={styles.notesWrapper}>
			{isNoteExist && (
				<>
					<DynamicIconWrapper
						icon={Icons.description}
						onClick={handleOpenNotes(false)}
						tooltipLabel={viewText}
					/>
				</>
			)}
			{!isReadOnly && (
				<>
					<DynamicIconWrapper
						icon={Icons.createIcon}
						onClick={handleOpenNotes(true)}
						tooltipLabel={editableNoteText}
					/>
				</>
			)}
		</div>
	);
};

export default NotesTableCell;
